import { render } from "./EditNinatrenn.vue?vue&type=template&id=6ae17688&scoped=true"
import script from "./EditNinatrenn.vue?vue&type=script&lang=js"
export * from "./EditNinatrenn.vue?vue&type=script&lang=js"

import "./EditNinatrenn.vue?vue&type=style&index=0&id=6ae17688&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae17688"]])

export default __exports__